import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { selectMemberProfile } from '@/state/member/memberSelectors';
import { useMemo } from 'react';

const useIsMemberAuthorized = () => {
    const { id: userId, verified } = useSelector((state: RootState) => selectMemberProfile(state));

    return useMemo(() => {
        return userId !== null && verified;
    }, [userId, verified]);
};

export default useIsMemberAuthorized;
